import { ObjectWrapperUtil } from './object.wrapper.util';
import { LAttribute } from '../models/domain/lattribute';
import { VennGroup } from '../models/domain/venngroup';
import { DxMp_Fwd_LnksUtil } from './dxmp_fwd_lnks.util';
import { LAttributesUtil } from '../grids/lattributes/lattributes.util';
import { ObjectWrapper } from '../wrappers/object.wrapper';
import { DatabaseWrappersFactory } from '../databases/database.wrappers.factory';
import { Venn_Grp_Attr } from '../models/domain/venn_grp_attr';

export class Venn_Grp_AttrsUtil {
    private static instance: Venn_Grp_AttrsUtil;

    static getInstance(): Venn_Grp_AttrsUtil {
        if (!Venn_Grp_AttrsUtil.instance) {
            Venn_Grp_AttrsUtil.instance = new Venn_Grp_AttrsUtil();
        }

        return Venn_Grp_AttrsUtil.instance;
    }

    objectWrapperUtil: ObjectWrapperUtil;
    lAttributesUtil: LAttributesUtil;
    dxMp_Fwd_LnksUtil: DxMp_Fwd_LnksUtil;
    /**
     * Venn_Grp_AttrsUtil is a singleton class, so use Venn_Grp_AttrsUtil.getInstance() method instead of creating new Venn_Grp_AttrsUtil().
     */
    private constructor() {
        this.objectWrapperUtil = ObjectWrapperUtil.getInstance();
        this.lAttributesUtil = LAttributesUtil.getInstance();
        this.dxMp_Fwd_LnksUtil = DxMp_Fwd_LnksUtil.getInstance();
    }

    getNewVenn_Grp_Attr(objectWrapper: ObjectWrapper, vennGroup: VennGroup,
        lnk_Obj_Id: number, lnk_Attr_Id: number): Venn_Grp_Attr {
        let venn_Grp_Attr: Venn_Grp_Attr = new Venn_Grp_Attr();

        venn_Grp_Attr.venn_Grp_Id = vennGroup.venn_Grp.venn_Grp_Id;
        venn_Grp_Attr.venn_Inst_Id = objectWrapper.obj_Id;

        venn_Grp_Attr.dxMp_Id = objectWrapper.designWrapper.obj_Id;

        venn_Grp_Attr.lnk_Obj_Id = lnk_Obj_Id;
        venn_Grp_Attr.lnk_Attr_Id = lnk_Attr_Id;

        return venn_Grp_Attr;
    }

    insert(venn_Grp_Attr: Venn_Grp_Attr, vennGroup: VennGroup, objectWrapper: ObjectWrapper) {
        vennGroup.venn_Grp_Attrs.push(venn_Grp_Attr);
    }

    addOrDelete(lAttributes: Array<LAttribute>, vennGroups: Array<VennGroup>,
        objectWrapper: ObjectWrapper, carryForwardAttributes: Array<any>,
        srt_Order: number, isAutoMap: boolean = false): void {
        if (vennGroups.length <= srt_Order) return;

        let vennGroup: VennGroup = vennGroups[srt_Order];

        let venn_Grp_AttrsHMapIds: Map<string, string> = new Map<string, string>();
        let unlinkedVenn_Grp_Attrs: Array<Venn_Grp_Attr> = new Array<Venn_Grp_Attr>();

        for (let i: number = 0; i < vennGroup.venn_Grp_Attrs.length; i++) {
            let venn_Grp_Attr: Venn_Grp_Attr = vennGroup.venn_Grp_Attrs[i];
            if (venn_Grp_Attr.lnk_Obj_Id == -1) {
                unlinkedVenn_Grp_Attrs.push(venn_Grp_Attr);
                continue;
            }

            venn_Grp_AttrsHMapIds.set(venn_Grp_Attr.lnk_Obj_Id + '-' + venn_Grp_Attr.lnk_Attr_Id, 'ATTR_NM_' + venn_Grp_Attr.srt_Order);
        }

        this._addOrDelete(vennGroup, carryForwardAttributes, venn_Grp_AttrsHMapIds, unlinkedVenn_Grp_Attrs, objectWrapper, isAutoMap);
        this.updateLAttributes(lAttributes, vennGroups, objectWrapper);
        this.objectWrapperUtil.resetSrt_Order(vennGroup.venn_Grp_Attrs);

        if (srt_Order == 0) {
            this.updateByVenn_Grp_Attrs(lAttributes, vennGroup.venn_Grp_Attrs,
                venn_Grp_AttrsHMapIds, objectWrapper)
            this.objectWrapperUtil.resetSrt_Order(lAttributes);
        }

        // find maxLength
        let maxLength = 0;
        for (let i: number = 0; i < vennGroups.length; i++) {
            let venn_Grp_Attrs: Array<Venn_Grp_Attr> = vennGroups[i].venn_Grp_Attrs;
            if (maxLength < venn_Grp_Attrs.length)
                maxLength = venn_Grp_Attrs.length;
        }

        // Add additional lAttributes.
        if (lAttributes.length < maxLength) {
            for (let i: number = lAttributes.length; i < maxLength; i++) {
                let lAttribute: LAttribute = this.lAttributesUtil.getNewLAttribute(objectWrapper, 'ATTR_NM_1', -1, -1);
                lAttribute.srt_Order = i;
                lAttribute.valid_Cd = 'NO_ATTR_LNK';
                this.lAttributesUtil.insert(lAttribute, lAttributes, objectWrapper);
            }
        }

        // Add additional venn_Grp_Attrs
        for (let i: number = 0; i < vennGroups.length; i++) {
            let vennGroup: VennGroup = vennGroups[i];
            if (vennGroup.venn_Grp_Attrs.length == maxLength) continue;

            for (let j: number = vennGroup.venn_Grp_Attrs.length; j < maxLength; j++) {
                let venn_Grp_AttrNew: Venn_Grp_Attr = this.getNewVenn_Grp_Attr(objectWrapper, vennGroup, -1, -1);
                venn_Grp_AttrNew.srt_Order = j;
                this.insert(venn_Grp_AttrNew, vennGroup, objectWrapper);
            }
        }

        // Validations
        for (let i: number = 0; i < lAttributes.length; i++) {
            this.validateVenn_Grp_Attr(lAttributes[i], vennGroups, objectWrapper);
        }

        objectWrapper.doValidate();
    }

    private _addOrDelete(vennGroup: VennGroup, carryForwardAttributes: Array<any>,
        venn_Grp_AttrsHMapIds: Map<string, string>, unlinkedVenn_Grp_Attrs: Array<Venn_Grp_Attr>,
        objectWrapper: ObjectWrapper, isAutoMap: boolean = false): void {
        for (let i: number = 0; i < carryForwardAttributes.length; i++) {
            let transformObject: any = carryForwardAttributes[i];

            for (let j: number = 0; j < transformObject.items.length; j++) {
                let attributeObject: any = transformObject.items[j];

                if (attributeObject.checked) {
                    if ((transformObject.dbTyp_Id == 30 || transformObject.dbTyp_Id == 32 || transformObject.dbTyp_Id == 33) &&
                        (attributeObject.attrDTyp_Id == 33 || !attributeObject.showUnderline))
                        continue;

                    // Already existed Venn_Grp_Attr
                    if (venn_Grp_AttrsHMapIds.get(transformObject.obj_Id + '-' + attributeObject.attr_Id) != null) {
                        venn_Grp_AttrsHMapIds.set(transformObject.obj_Id + '-' + attributeObject.attr_Id, attributeObject.text);
                        continue;
                    }

                    // unlinked Venn_Grp_Attr
                    if (unlinkedVenn_Grp_Attrs.length != 0) {
                        let unlinkedVenn_Grp_Attr = unlinkedVenn_Grp_Attrs[0];

                        unlinkedVenn_Grp_Attr.lnk_Obj_Id = attributeObject.obj_Id;
                        unlinkedVenn_Grp_Attr.lnk_Attr_Id = attributeObject.attr_Id;

                        unlinkedVenn_Grp_Attrs.splice(0, 1);
                        continue;
                    }

                    // New Venn_Grp_Attr
                    let venn_Grp_AttrNew: Venn_Grp_Attr = this.getNewVenn_Grp_Attr(objectWrapper, vennGroup, attributeObject.obj_Id, attributeObject.attr_Id);
                    venn_Grp_AttrNew.srt_Order = vennGroup.venn_Grp_Attrs.length;

                    this.insert(venn_Grp_AttrNew, vennGroup, objectWrapper);
                    venn_Grp_AttrsHMapIds.set(transformObject.obj_Id + '-' + attributeObject.attr_Id, attributeObject.text);
                } else {
                    let venn_Grp_AttrSrt_Order = venn_Grp_AttrsHMapIds.get(transformObject.obj_Id + '-' + attributeObject.attr_Id);
                    if (venn_Grp_AttrSrt_Order == null) continue;

                    for (let k = 0; k < vennGroup.venn_Grp_Attrs.length; k++) {
                        let venn_Grp_Attr = vennGroup.venn_Grp_Attrs[k];
                        if (venn_Grp_Attr.lnk_Obj_Id == transformObject.obj_Id &&
                            venn_Grp_Attr.lnk_Attr_Id == attributeObject.attr_Id) {
                            vennGroup.venn_Grp_Attrs.splice(k, 1);
                            break;
                        }
                    }
                }
            }
        }
    }


    updateLAttributes(lAttributes: Array<LAttribute>, vennGroups: Array<VennGroup>, objectWrapper: ObjectWrapper): void {
        if (vennGroups.length == 0) return;

        for (let i: number = 0; i < lAttributes.length; i++) {
            this.updateLAttribute(vennGroups[0], lAttributes[i], objectWrapper);
        }
    }

    updateLAttribute(vennGroup: VennGroup, lAttribute: LAttribute, objectWrapper: ObjectWrapper): void {
        if (vennGroup.venn_Grp.srt_Order > 0) return;

        let venn_Grp_Attr: Venn_Grp_Attr = vennGroup.venn_Grp_Attrs[lAttribute.srt_Order];
        if (!venn_Grp_Attr) {
            lAttribute.lnk_Obj_Inst_Id = -1;
            lAttribute.lnk_Attr_Id = -1;
            return;
        }

        lAttribute.lnk_Obj_Inst_Id = venn_Grp_Attr.lnk_Obj_Id;
        lAttribute.lnk_Attr_Id = venn_Grp_Attr.lnk_Attr_Id;
    }

    validateVenn_Grp_Attr(lAttribute: LAttribute, vennGroups: Array<VennGroup>, objectWrapper: ObjectWrapper): string {
        lAttribute.valid_Cd = '0';

        let family: number = -1;
        for (let i: number = 0; i < vennGroups.length; i++) {
            let vennGroup: VennGroup = vennGroups[i];

            let venn_Grp_Attr: Venn_Grp_Attr = vennGroup.venn_Grp_Attrs[lAttribute.srt_Order];
            if (!venn_Grp_Attr) {
                lAttribute.valid_Cd = 'NO_LNK';
                break;
            }

            let attributeObject: any = objectWrapper.carryForwardAttributeObjectsHMapIds.get(venn_Grp_Attr.lnk_Obj_Id + '-' + venn_Grp_Attr.lnk_Attr_Id);
            if (attributeObject == undefined) {
                lAttribute.valid_Cd = "INV_LATTRS";
                break;
            }

            let datatype = DatabaseWrappersFactory.getInstance().getDatatype(objectWrapper.nativeDbTyp_Id, attributeObject.attrDTyp_Id);
            if (datatype) {
                if (family != -1 &&
                    datatype.family != family) {
                    lAttribute.valid_Cd = 'NOT_SAME_FAMILY';
                    break;
                }

                family = datatype.family;
            }
        }

        return lAttribute.valid_Cd;
    }

    updateByVenn_Grp_Attrs(lAttributes: Array<LAttribute>, venn_Grp_Attrs: Array<Venn_Grp_Attr>,
        venn_Grp_AttrsHMapIds: Map<string, string>, objectWrapper: ObjectWrapper) {
        /*let lAttributesHMapIds = [];
        let lAttributesTmp = transformWrapper.lAttributes;
        
        DONT REMOVE
         * for( let i = 0; i < transformWrapper.lAttributes.length; i++ ) {
            let lAttribute = transformWrapper.lAttributes[i];
            lAttributesHMapIds[ lAttribute.lnk_Obj_Inst_Id + '-' + lAttribute.lnk_Attr_Id ] = lAttribute;
        }
        
        factoryObj.removeAll( transformWrapper.lAttributes, transformWrapper );
        */

        for (let i: number = 0; i < venn_Grp_Attrs.length; i++) {
            let venn_Grp_Attr: Venn_Grp_Attr = venn_Grp_Attrs[i];

            if (lAttributes.length > i) {
                let lAttribute: LAttribute = lAttributes[i];
                lAttribute.lnk_Attr_Id = venn_Grp_Attr.lnk_Attr_Id;
                lAttribute.lnk_Obj_Inst_Id = venn_Grp_Attr.lnk_Obj_Id;
                continue;
            }

            /*DONT REMOVE
             let lAttribute = lAttributesHMapIds[venn_Grp_Attr.lnk_Obj_Id + '-' + venn_Grp_Attr.lnk_Attr_Id];
            if( lAttribute ) {
                factoryObj.insert( lAttribute, lAttributes, transformWrapper );
                continue;
            }*/

            let lAttrNm = venn_Grp_AttrsHMapIds.get(venn_Grp_Attr.lnk_Obj_Id + '-' + venn_Grp_Attr.lnk_Attr_Id);
            if (!lAttrNm) lAttrNm = 'ATTR_NM_' + venn_Grp_Attr.srt_Order;

            let lAttribute = this.lAttributesUtil.getNewLAttribute(objectWrapper, lAttrNm, venn_Grp_Attr.lnk_Attr_Id, venn_Grp_Attr.lnk_Obj_Id);

            lAttribute.srt_Order = lAttributes.length;
            this.lAttributesUtil.insert(lAttribute, lAttributes, objectWrapper);
        }
    }

    getSelectedTransformObject(objectWrapper: ObjectWrapper, vennGroup: VennGroup) {
        let dxMp_Fwd_LnkObj_Ids: Array<number> = this.dxMp_Fwd_LnksUtil.getPreceedingTransform_Ids(objectWrapper.obj_Id, vennGroup.venn_Grp.venn_Grp_Id, objectWrapper.designWrapper.design.dxMp_Fwd_Lnks)

        let selectedTransformObjects: Array<any> = new Array<any>();
        for (let i: number = 0; i < objectWrapper.carryForwardAttributes.length; i++) {
            let carryForwardAttribute: any = objectWrapper.carryForwardAttributes[i];

            if (dxMp_Fwd_LnkObj_Ids.indexOf(carryForwardAttribute.obj_Id) != -1) {
                for (let j: number = 0; j < carryForwardAttribute.items.length; j++) {
                    selectedTransformObjects.push(carryForwardAttribute.items[j]);
                }
            }
        }

        return selectedTransformObjects;
    }

    getPrimaryKey(venn_Grp_Attr: Venn_Grp_Attr): string {
        return venn_Grp_Attr.venn_Inst_Id + '.' + venn_Grp_Attr.venn_Grp_Id + '.' + venn_Grp_Attr.lnk_Obj_Id + '.' + venn_Grp_Attr.lnk_Attr_Id;
    }

    copy(venn_Grp_AttrsTmp: Array<Venn_Grp_Attr>): Array<Venn_Grp_Attr> {
        let venn_Grp_Attrs: Array<Venn_Grp_Attr> = new Array<Venn_Grp_Attr>();

        for (let i: number = 0; i < venn_Grp_AttrsTmp.length; i++) {
            venn_Grp_Attrs.push(Venn_Grp_Attr.parse(venn_Grp_AttrsTmp[i]));
        }

        return venn_Grp_Attrs;
    }

    copyFrom(venn_Grp_Attrs: Array<Venn_Grp_Attr>, venn_Grp_AttrsTmp: Array<Venn_Grp_Attr>): void {
        let venn_Grp_AttrsMap: Map<string, Venn_Grp_Attr> = new Map<string, Venn_Grp_Attr>();

        for (let i: number = 0; i < venn_Grp_Attrs.length; i++) {
            let venn_Grp_Attr: Venn_Grp_Attr = venn_Grp_Attrs[i];
            venn_Grp_AttrsMap.set(this.getPrimaryKey(venn_Grp_Attr), venn_Grp_Attr);
        }
        venn_Grp_Attrs.splice(0, venn_Grp_Attrs.length);

        for (let i: number = 0; i < venn_Grp_AttrsTmp.length; i++) {
            let venn_Grp_AttrTmp: Venn_Grp_Attr = venn_Grp_AttrsTmp[i];

            let venn_Grp_Attr: Venn_Grp_Attr = venn_Grp_AttrsMap.get(this.getPrimaryKey(venn_Grp_AttrTmp));
            if (venn_Grp_Attr) {
                venn_Grp_Attr.copyFrom(venn_Grp_AttrTmp);
            } else {
                venn_Grp_Attr = Venn_Grp_Attr.parse(venn_Grp_AttrTmp);
            }

            venn_Grp_Attrs.push(venn_Grp_Attr);
        }
    }

    compare(venn_Grp_Attrs: Array<Venn_Grp_Attr>, venn_Grp_AttrsTmp: Array<Venn_Grp_Attr>): string {
        let venn_Grp_AttrsLength = venn_Grp_Attrs.length;
        let venn_Grp_AttrsTmpLength = venn_Grp_AttrsTmp.length;

        if (venn_Grp_AttrsLength != venn_Grp_AttrsTmpLength) {
            return 'venn_Grp_Attrs length is different.';
        }

        for (let i: number = 0; i < venn_Grp_AttrsLength; i++) {
            if (venn_Grp_Attrs[i].compare(venn_Grp_AttrsTmp[i]) != '') {
                return 'venn_Grp_Attrs [' + i + '] is not equal.'
            }
        }

        return '';
    }

    toString(venn_Grp_Attrs: Array<Venn_Grp_Attr>): string {
        let str: string = '';

        str += 'venn_Grp_Attrs length: ' + venn_Grp_Attrs.length + ' ';

        for (let i: number = 0; i < venn_Grp_Attrs.length; i++) {
            str += venn_Grp_Attrs[i].toString();
        }

        return str;
    }
}